// extracted by mini-css-extract-plugin
export default {"refineContainer":"CustomToggleRefinement_refineContainer__MKMZ1","span":"CustomToggleRefinement_span__dOWod","selected":"CustomToggleRefinement_selected__JqO3H"};